import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Input } from './ui/Input';
import { Label } from './ui/Label';
import { Textarea } from './ui/Textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/Select';
import { Button } from './ui/Button';
import { Phone, ShieldCheck, MessageCircle } from 'lucide-react';
export function QuoteForm() {
  return <section id="quote" className="py-20 md:py-28 bg-[#FBFCFB]" data-id="element-122">
      <div className="container mx-auto px-4" data-id="element-123">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-124">
          <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-125">
            Get Started
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy mb-4" data-id="element-126">
            Request Your Free Visit
          </h2>
          <p className="text-lg text-gray-600 font-body" data-id="element-127">
            Fill out the form below and we will call you within 24 hours to
            confirm.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-128">
          {/* Form */}
          <div className="lg:col-span-2" data-id="element-129">
            <Card className="border-0 shadow-xl rounded-3xl overflow-hidden" data-id="element-130">
              <CardContent className="p-8 md:p-10" data-id="element-131">
                <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-132">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-133">
                    <div className="space-y-3" data-id="element-134">
                      <Label htmlFor="fullName" className="text-gray-700 font-semibold" data-id="element-135">
                        Full Name
                      </Label>
                      <Input id="fullName" placeholder="John Doe" className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-136" />
                    </div>
                    <div className="space-y-3" data-id="element-137">
                      <Label htmlFor="phone" className="text-gray-700 font-semibold" data-id="element-138">
                        Phone Number
                      </Label>
                      <Input id="phone" type="tel" placeholder="(915) 000-0000" className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-139" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-140">
                    <div className="space-y-3" data-id="element-141">
                      <Label htmlFor="email" className="text-gray-700 font-semibold" data-id="element-142">
                        Email Address
                      </Label>
                      <Input id="email" type="email" placeholder="john@example.com" className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-143" />
                    </div>
                    <div className="space-y-3" data-id="element-144">
                      <Label htmlFor="address" className="text-gray-700 font-semibold" data-id="element-145">
                        Service Address
                      </Label>
                      <Input id="address" placeholder="123 Main St, Horizon City" className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-146" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-147">
                    <div className="space-y-3" data-id="element-148">
                      <Label className="text-gray-700 font-semibold" data-id="element-149">
                        Service Type
                      </Label>
                      <Select data-id="element-150">
                        <SelectTrigger className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-151">
                          <SelectValue placeholder="Select service type" data-id="element-152" />
                        </SelectTrigger>
                        <SelectContent data-id="element-153">
                          <SelectItem value="residential" data-id="element-154">
                            Residential Cleaning
                          </SelectItem>
                          <SelectItem value="commercial" data-id="element-155">
                            Commercial Cleaning
                          </SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-3" data-id="element-156">
                      <Label className="text-gray-700 font-semibold" data-id="element-157">
                        Frequency
                      </Label>
                      <Select data-id="element-158">
                        <SelectTrigger className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-159">
                          <SelectValue placeholder="Select frequency" data-id="element-160" />
                        </SelectTrigger>
                        <SelectContent data-id="element-161">
                          <SelectItem value="one-time" data-id="element-162">One-time</SelectItem>
                          <SelectItem value="weekly" data-id="element-163">Weekly</SelectItem>
                          <SelectItem value="bi-weekly" data-id="element-164">Bi-weekly</SelectItem>
                          <SelectItem value="monthly" data-id="element-165">Monthly</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>

                  <div className="space-y-3" data-id="element-166">
                    <Label className="text-gray-700 font-semibold" data-id="element-167">
                      Home Size / Space
                    </Label>
                    <Select data-id="element-168">
                      <SelectTrigger className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-169">
                        <SelectValue placeholder="Select size" data-id="element-170" />
                      </SelectTrigger>
                      <SelectContent data-id="element-171">
                        <SelectItem value="small" data-id="element-172">
                          Studio / Small under 800 sq ft
                        </SelectItem>
                        <SelectItem value="medium" data-id="element-173">
                          Medium 800 to 1,400 sq ft
                        </SelectItem>
                        <SelectItem value="large" data-id="element-174">
                          Large 1,400 to 2,200 sq ft
                        </SelectItem>
                        <SelectItem value="xlarge" data-id="element-175">
                          Extra Large 2,200+ sq ft
                        </SelectItem>
                        <SelectItem value="commercial" data-id="element-176">
                          Commercial please describe below
                        </SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-177">
                    <div className="space-y-3" data-id="element-178">
                      <Label className="text-gray-700 font-semibold" data-id="element-179">
                        Preferred Date
                      </Label>
                      <Input type="date" className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-180" />
                    </div>
                    <div className="space-y-3" data-id="element-181">
                      <Label className="text-gray-700 font-semibold" data-id="element-182">
                        Preferred Time
                      </Label>
                      <Select data-id="element-183">
                        <SelectTrigger className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-184">
                          <SelectValue placeholder="Select time" data-id="element-185" />
                        </SelectTrigger>
                        <SelectContent data-id="element-186">
                          <SelectItem value="morning" data-id="element-187">
                            Morning 8am to 12pm
                          </SelectItem>
                          <SelectItem value="afternoon" data-id="element-188">
                            Afternoon 12pm to 4pm
                          </SelectItem>
                          <SelectItem value="flexible" data-id="element-189">Flexible</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>

                  <div className="space-y-3" data-id="element-190">
                    <Label className="text-gray-700 font-semibold" data-id="element-191">
                      Communication Language
                    </Label>
                    <Select defaultValue="english" data-id="element-192">
                      <SelectTrigger className="h-12 bg-gray-50 border-gray-200 rounded-xl" data-id="element-193">
                        <SelectValue placeholder="Select language" data-id="element-194" />
                      </SelectTrigger>
                      <SelectContent data-id="element-195">
                        <SelectItem value="english" data-id="element-196">English</SelectItem>
                        <SelectItem value="espanol" data-id="element-197">Español</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  <div className="space-y-3" data-id="element-198">
                    <Label htmlFor="notes" className="text-gray-700 font-semibold" data-id="element-199">
                      Special Notes (optional)
                    </Label>
                    <Textarea id="notes" placeholder="Any specific areas to focus on, pets in the home, or commercial space details?" className="min-h-[120px] bg-gray-50 border-gray-200 rounded-xl resize-none" data-id="element-200" />
                  </div>

                  <Button className="w-full h-14 rounded-xl brand-gradient text-white font-bold text-lg border-0 hover:opacity-90 shadow-lg mt-4" data-id="element-201">
                    Request My Free Visit
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          {/* Side Panel */}
          <div className="lg:col-span-1" data-id="element-202">
            <div className="sticky top-32 space-y-6" data-id="element-203">
              <Card className="border-0 shadow-lg rounded-3xl bg-brand-navy text-white overflow-hidden" data-id="element-204">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-16 -mt-16 blur-2xl" data-id="element-205" />
                <CardContent className="p-8 relative z-10" data-id="element-206">
                  <h3 className="text-2xl font-heading font-bold mb-6" data-id="element-207">
                    We Are Here to Help
                  </h3>

                  <div className="space-y-8" data-id="element-208">
                    <div className="flex items-start" data-id="element-209">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-210">
                        <Phone className="w-6 h-6 text-brand-green" data-id="element-211" />
                      </div>
                      <div data-id="element-212">
                        <p className="text-white/70 text-sm font-medium mb-1" data-id="element-213">
                          Call Us Directly
                        </p>
                        <a href="tel:9159795151" className="text-xl font-bold hover:text-brand-green transition-colors" data-id="element-214">
                          (915) 979-5151
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start" data-id="element-215">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-216">
                        <ShieldCheck className="w-6 h-6 text-brand-green" data-id="element-217" />
                      </div>
                      <div data-id="element-218">
                        <p className="text-white/70 text-sm font-medium mb-1" data-id="element-219">
                          Our Guarantee
                        </p>
                        <p className="font-medium" data-id="element-220">
                          On time every time, or your next clean is free.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start" data-id="element-221">
                      <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-222">
                        <MessageCircle className="w-6 h-6 text-brand-green" data-id="element-223" />
                      </div>
                      <div data-id="element-224">
                        <p className="text-white/70 text-sm font-medium mb-1" data-id="element-225">
                          Bilingual Team
                        </p>
                        <p className="font-medium" data-id="element-226">
                          Hablamos Español. Clear communication always.
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}